module.exports = __webpack_public_path__ + "img/38_76.62472fa2.png";